import React from "react";
import filter from "../../../assets/common/filter-icon.svg";
import pagesIcon from "../../../assets/common/perPage-icon.svg";
import tick from "../../../assets/dashboard/tick.svg";

const PAGE_OPTIONS = [10, 20, 30, 40, 50, 100];

const PageSizeFilter = ({
    value,
    onChange,
    className = "",
}) => {
    const [open, setOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);

    // Close on outside click
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div ref={dropdownRef} className={`relative ${className}`}>
            {/* Button */}
            <button
                onClick={() => setOpen((prev) => !prev)}
                className="w-14 h-9 border border-secondary rounded-md flex items-center justify-center"
            >
                <img
                    src={filter}
                    alt="filter"
                    className="w-4 h-4"
                />
            </button>

            {/* Dropdown */}
            {open && (
                <div className="absolute right-0 mt-2 py-2 w-40 bg-white border border-gray-200 rounded-md shadow-xl z-50 overflow-hidden">
                    <div className="flex items-center justify-center gap-[6px] border-b mx-3">
                        <img src={pagesIcon} alt="pagesIcon" className="w-2 h-2" />
                        <p className="text-sm">Show per page</p>
                    </div>
                    {PAGE_OPTIONS.map((num) => (
                        <div
                            key={num}
                            onClick={() => {
                                onChange(num);
                                setOpen(false);
                            }}
                            className={`flex items-center justify-center gap-[2px] mx-1 mt-2 py-1 text-sm cursor-pointer transition rounded-md
                ${value === num
                                    ? "bg-lightBlue font-semibold text-primary"
                                    : "hover:bg-lightBlue"
                                }`}
                        >
                            {value === num && (
                                <span className="text-primary font-bold"><img src={tick} alt="tick" className="w-2 h-2" /></span>
                            )}
                            {num}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PageSizeFilter;
